<template>
  <v-dialog v-model="active" max-width="500px" persistent class="l-dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind="{ on: on }" />
    </template>
    <v-card>
      <v-card-title>{{ titulo }}</v-card-title>
      <v-divider />
      <v-card-text>
        <v-container fluid>
          <v-row class="ma-0 d-flex flex-column">
            <span class="py-1">
              {{ dsAcao }}
            </span>
            <span class="py-1 font-weight-bold">
            {{ mensagem }}
            </span>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn @click="active = false">
          Fechar
        </v-btn>
        <v-spacer />
        <v-btn color="error" @click="onConfirmClick">
          Sim, {{ deletar ? 'Deletar' : 'Cancelar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  data: () => ({
    active: false,
  }),
  props: {
    titulo: String,
    dsAcao: String,
    mensagem: String,
    deletar: Boolean,
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    onConfirmClick() {
      this.$emit("confirmed")
      this.active = false
    }
  }
}
</script>